export const locales = [
    {label: "de-DE", value: "de-DE"},
    {label: "de-AT", value: "de-AT"},
    {label: "de-CH", value: "de-CH"},
    {label: "fr-CH", value: "fr-CH"},
    {label: "fr-BE", value: "fr-BE"},
    {label: "nl-BE", value: "nl-BE"},
    {label: "nl-NL", value: "nl-NL"},
    {label: "en-GB", value: "en-GB"},
    {label: "it-IT", value: "it-IT"},
    {label: "fr-CA", value: "fr-CA"},
    {label: "en-US", value: "en-US"},
    {label: "fr-FR", value: "fr-FR"},
    {label: "en-AU", value: "en-AU"},
    {label: "en-CA", value: "en-CA"},
    {label: "es-ES", value: "es-ES"},
    {label: "es-MX", value: "es-MX"},
    {label: "es-AR", value: "es-AR"},
    {label: "pt-PT", value: "pt-PT"},
    {label: "pt-BR", value: "pt-BR"},
    {label: "sv-SE", value: "sv-SE"},
    {label: "da-DK", value: "da-DK"},
    {label: "fi-FI", value: "fi-FI"},
    {label: "no-NO", value: "no-NO"},
    {label: "ru-RU", value: "ru-RU"},
    {label: "pl-PL", value: "pl-PL"},
    {label: "cs-CZ", value: "cs-CZ"},
    {label: "hu-HU", value: "hu-HU"},
    {label: "el-GR", value: "el-GR"},
    {label: "tr-TR", value: "tr-TR"},
    {label: "zh-CN", value: "zh-CN"},
    {label: "zh-TW", value: "zh-TW"},
    {label: "ja-JP", value: "ja-JP"},
    {label: "ko-KR", value: "ko-KR"},
    {label: "ar-SA", value: "ar-SA"},
    {label: "he-IL", value: "he-IL"},
    {label: "hi-IN", value: "hi-IN"},
    {label: "th-TH", value: "th-TH"},
    {label: "vi-VN", value: "vi-VN"},
    {label: "ms-MY", value: "ms-MY"},
    {label: "id-ID", value: "id-ID"},
    {label: "uk-UA", value: "uk-UA"},
    {label: "bg-BG", value: "bg-BG"},
    {label: "ro-RO", value: "ro-RO"},
    {label: "sk-SK", value: "sk-SK"},
    {label: "lt-LT", value: "lt-LT"},
    {label: "lv-LV", value: "lv-LV"},
    {label: "et-EE", value: "et-EE"}
]
